import { ServerEnv } from 'shared/sharedTypes/common/misc';

declare const serverEnv: ServerEnv;

export function FFEmblem({ margin }: { margin: string }) {
    let envColor;

    switch (serverEnv) {
        case 'qa':
            envColor = '#808';
            break;
        case 'apollo':
            envColor = '#800';
            break;
        /*case 'gemini':
            envColor = '#996535';
            break;*/
        default:
            envColor = '#FFF';
    }

    const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    el.style.margin = margin;
    el.style.overflow = 'visible';
    el.setAttribute('width', '40px');
    el.setAttribute('height', '40px');
    el.setAttributeNS(null, 'viewBox', '0 0 508 508');
    el.innerHTML = `
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-72.000000, -1098.000000)" fill=${
                envColor || '#FFF'
            } fill-rule="nonzero">
                <g transform="translate(72.000000, 1098.000000)">
                    <path d="M376,287 L508,254 L376,221 L474,127 L343,164 L381,34 L287,132 C340,146 378,195 378,252 C378,321 322,377 253,377 C184,377 128,321 128,252 C128,218 141,187 164,164 L34,127 L132,221 L0,254 L131,287 L34,381 L165,344 L127,474 L221,377 L254,508 L287,377 L381,474 L343,344 L474,381 L376,287 Z M220,131 L127,34 L164,164 C180,148 199,137 220,131 Z M287,132 L254,0 L221,131 C232,128 242,126 253,126 C265,127 276,128 287,132 Z M254,157 C241,157 238,187 238,187 L237,227 L151,264 L158,277 L238,266 L240,308 L213,331 L216,341 L242,334 L246,350 L251,351 L258,351 L263,350 L267,334 L293,341 L296,331 L268,309 L270,267 L350,277 L357,264 L271,227 L270,187 C270,187 268,157 254,157 Z"></path>
                </g>
            </g>
        </g>
        `;
    return el;
}

export function LogoWithBoeing({ margin }: { margin: string }) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    el.setAttribute('style', `margin: ${margin}`);
    el.setAttribute('width', '100px');
    el.setAttribute('height', '40px');
    el.setAttributeNS(null, 'viewBox', '400 500 750 200');
    el.setAttribute('id', 'logo-with-boeing');

    el.innerHTML = `
            <g fill="#FFFFFF">
                <path d="M450.34,549.45h61.54v14.97h-42.08v27.55h39.23v14.97h-39.23v42.37h-19.46v-99.87Z"/>
                <path d="M599.81,612.57c0,26.52-19.94,38.38-39.55,38.38-21.84,0-38.6-14.08-38.6-37.19s16.61-38.23,39.87-38.23,38.28,15.11,38.28,37.04ZM541.75,613.31c0,13.92,7.27,24.45,19.14,24.45,11.08,0,18.83-10.23,18.83-24.74,0-11.26-5.38-24.15-18.67-24.15s-19.3,12.44-19.3,24.45Z"/>
                <path d="M614.05,600.42c0-9.78-.16-16.74-.63-23.26h16.93l.63,13.78h.64c3.79-10.23,12.81-15.41,21.04-15.41,1.9,0,3,.15,4.59.45v17.19c-1.58-.3-3.32-.59-5.7-.59-9.33,0-15.66,5.63-17.4,13.77-.32,1.63-.64,3.56-.64,5.63v37.34h-19.46v-48.89Z"/>
                <path d="M682.33,618.35c.48,13.04,11.39,18.67,23.73,18.67,9.02,0,15.51-1.18,21.36-3.26l2.85,12.6c-6.65,2.51-15.82,4.44-26.89,4.44-25,0-39.71-14.37-39.71-36.45,0-20,12.97-38.82,37.65-38.82s33.22,19.26,33.22,35.11c0,3.41-.31,6.08-.64,7.71h-51.57ZM716.19,605.61c.16-6.67-3-17.63-15.98-17.63-12.03,0-17.08,10.22-17.88,17.63h33.85Z"/>
                <path d="M750.29,549.45h61.54v14.97h-42.08v27.55h39.23v14.97h-39.23v42.37h-19.46v-99.87Z"/>
                <path d="M825.52,544.12h19.62v105.2h-19.62v-105.2Z"/>
                <path d="M884.8,557.01c0,5.48-4.27,9.78-11.07,9.78s-10.76-4.3-10.76-9.78,4.43-9.93,10.92-9.93,10.75,4.3,10.91,9.93ZM864.08,649.32v-72.16h19.62v72.16h-19.62Z"/>
                <path d="M973.02,577.16c-.32,4.89-.64,10.82-.64,20.74v40.89c0,15.11-3.32,25.93-11.39,32.75-8.07,6.67-19.14,8.74-29.74,8.74-9.81,0-20.25-1.93-26.89-5.78l4.27-13.78c4.91,2.67,13.13,5.48,22.46,5.48,12.65,0,22.15-6.22,22.15-21.78v-6.23h-.32c-4.43,6.38-12.34,10.67-22.46,10.67-19.14,0-32.75-14.81-32.75-35.26,0-23.71,16.45-38.08,34.96-38.08,11.71,0,18.67,5.34,22.31,11.26h.31l.79-9.63h16.93ZM952.92,606.05c0-1.63-.16-3.4-.63-4.89-2.06-6.67-7.6-11.7-15.82-11.7-10.91,0-18.99,8.89-18.99,23.56,0,12.29,6.65,22.22,18.82,22.22,7.28,0,13.6-4.44,15.82-10.96.48-1.93.79-4.45.79-6.52v-11.71Z"/>
                <path d="M991.47,544.12h19.62v42.97h.31c2.38-3.4,5.54-6.22,9.65-8.29,3.8-2.08,8.38-3.26,13.29-3.26,13.13,0,26.89,8.15,26.89,31.26v42.52h-19.46v-40.45c0-10.52-4.11-18.37-14.87-18.37-7.6,0-12.97,4.74-15.03,10.23-.63,1.48-.79,3.41-.79,5.48v43.12h-19.62v-105.2Z"/>
                <path d="M1101.49,556.56v20.6h18.51v13.63h-18.51v31.86c0,8.74,2.53,13.34,9.97,13.34,3.32,0,5.85-.45,7.59-.89l.32,13.93c-2.85,1.04-7.91,1.78-14.08,1.78-7.12,0-13.13-2.22-16.77-5.92-4.11-4.15-6.01-10.67-6.01-20.16v-33.93h-11.07v-13.63h11.07v-16.3l18.98-4.3Z"/>
            </g>
    
    `;

    return el;
}
